import createModule from "../createModule"
import { Creators } from "./model"
import { getHasError, getTerms, getTermsLicense, getTermsVersion } from "./selectors"
import view from "./view"

export default createModule({
  externalProps: (state) => ({
    account: state.global.selected.account,
  }),
  required: ["account"],
  data: [{
    resource: "accountTerms",
    as: null,
    noToken: true,
    url: ({ account }) => `/api/${account}/terms`,
  }],
  mapStateToProps: (state) => ({
    terms: getTerms(state),
    termsLicense: getTermsLicense(state),
    hasError: getHasError(state),
    termsVersion: getTermsVersion(state),
  }),
  actions: {
    ...Creators,
  },
  view,
})
